module.exports = __webpack_public_path__ + "img/1.95ca2973.png";